


export function isPromise(obj) {
  return !!obj &&
    (typeof obj === 'object' || typeof obj === 'function') &&
    ((obj.constructor && obj.constructor.name === 'Promise') || typeof obj.then === 'function')
}

// 函数防抖
export function debounce(callback, delay) {
  let lastTime
  let interval = delay || 1000

  return function () {
    clearTimeout(lastTime)

    const [that, args] = [this, arguments]

    lastTime = setTimeout(() => {
      callback.apply(that, args)
    }, interval)
  }
}

/*函数节流*/
export function throttle(fn, interval) {
  var enterTime = 0;//触发的时间
  var gapTime = interval || 300;//间隔时间，如果interval不传，则默认300ms
  return function () {
    var context = this;
    var backTime = new Date();//第一次函数return即触发的时间
    if (backTime - enterTime > gapTime) {
      fn.apply(context, arguments);
      enterTime = backTime;//赋值给第一次触发的时间，这样就保存了第二次触发的时间
    }
  };
}

export function throttleDebounce(fn, delay = 100, interval = 100) {
  let task;
  let lastTime = 0;
  return function () {
    let [ctx, args] = [this, arguments];
    let _now = new Date();
    if (_now - lastTime > delay) {
      clearTimeout(task)
      fn.apply(ctx, args);
      lastTime = _now;
    } else {
      clearTimeout(task)
      task = setTimeout(() => {
        fn.apply(ctx, args)
      }, interval)
    }
  }

}